import React from "react";

export const Contour = ({ gridArea }: { gridArea: string }) => {
  return (
    <div
      id="Contour"
      style={{
        gridArea,
        borderRadius: "0.75rem",
        borderWidth: "8px",
        borderColor: "rgba(229, 231, 235, 0.1)",
        borderStyle: "solid",
      }}
    ></div>
  );
};
